import React, { useCallback, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { MaterialIcon } from '~src/new/shared/ui/MaterialIcon/MaterialIcon'
import cls from './header-search-field.module.scss'
import { HeaderDropdown } from './HeaderDropdown'
import { useSearchResults } from '~src/new/widgets/Search'
import { HeaderSearchResults } from './HeaderSearchResults'
import { useSearchHistory } from '~src/new/widgets/Search/lib/useSearch'

/**
 * Десктопное поле поиска (триггер для dropdown или модального листа).
 */
export const HeaderSearchField = ({
  placeholder = 'Введите запрос...',
  className,
  isMobile = false,
  onClick,
}) => {
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false)
  const { searchResults, searchString, changeSearchString, loadMoreScroll, isLoading } =
    useSearchResults()
  const [searchHistory, addSearchHistory] = useSearchHistory()

  const handleSearchClose = useCallback(
    () => setIsSearchDropdownOpen(false),
    [setIsSearchDropdownOpen],
  )

  const handleFocusSearch = useCallback(() => {
    setIsSearchDropdownOpen(true)
  }, [setIsSearchDropdownOpen])

  const inputRef = useRef(null)

  const handleContainerClick = useCallback(() => {
    inputRef.current?.focus()
  }, [inputRef?.current])

  const handleClickItem = useCallback(
    item => () => {
      handleSearchClose()
      addSearchHistory(item).finally()
      onClick?.()
    },
    [addSearchHistory, handleSearchClose, onClick],
  )

  const content = useMemo(() => {
    const searchDataToRender =
      searchResults?.length > 0 ? searchResults : !searchString && searchHistory

    const title = !searchResults?.length ? 'Последнее' : undefined

    const emptyText = !!searchString ? (isLoading ? 'Загрузка...' : 'Ничего не найдено') : undefined

    return (
      <HeaderSearchResults
        title={title}
        items={searchDataToRender}
        emptyText={emptyText}
        onClickItem={handleClickItem}
      />
    )
  }, [searchHistory, searchResults, searchString, isLoading, handleClickItem])

  return (
    <div id="header-search" style={{ width: '100%' }}>
      <div className={classNames(cls.searchField, className)} onClick={handleContainerClick}>
        <MaterialIcon name="search" ariaLabel="Поиск" className={cls.icon} />
        <input
          ref={inputRef}
          className={classNames(cls.text)}
          value={searchString}
          onChange={changeSearchString}
          placeholder={placeholder}
          onFocus={handleFocusSearch}
          name="search"
        />

        {!isMobile && (
          <HeaderDropdown
            isLoading={isLoading}
            isOpen={isSearchDropdownOpen}
            onClose={handleSearchClose}
            align="center"
            maxHeight={296}
            onScroll={loadMoreScroll}
          >
            {content}
          </HeaderDropdown>
        )}
      </div>
      {isMobile && content}
    </div>
  )
}

HeaderSearchField.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
}
